import React from 'react';
import tpl from '../templates/diia';
import BaseNewCardView from '../../views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            where_by_2: ['path'],
            search_by_2: ['/cards/diia_veteransport'],
            widgets_2: [],
            widgets_4: [],
            widgets_5: [],
            widgets_7: [],
            widgets_8: [],
            widgets_childcare: [],
            widgets_malyatko: [],
            tabInfo: 'ebook',
            tabShortQuestions: 'general-questions-short',
            tabAllQuestions: 'general-questions-full',
            tab: 'tariffs'
        };
    }

    shouldFetchData() {
        return false;
    }

    componentDidMount() {
        super.componentDidMount();
        const fetches = [
            this.widgetsHelper.getWidgets.call(this),
            this.widgetsHelper.getWidgets_2.call(this),
            this.widgetsHelper.getWidgetsByPath.call(this, {
                path: '/cards/diia_basic_social_assistance',
                widgetKey: 'widgets_4'
            }),
            this.widgetsHelper.getWidgetsByPath.call(this, {
                path: '/cards/diia_general_questions',
                widgetKey: 'widgets_5'
            }),
            this.widgetsHelper.getWidgetsByPath.call(this, {
                path: '/cards/diia_health40plus',
                widgetKey: 'widgets_7'
            }),
            this.widgetsHelper.getWidgetsByPath.call(this, {
                path: '/cards/diia_insurance_veterans',
                widgetKey: 'widgets_8'
            }),
            this.widgetsHelper.getWidgetsByPath.call(this, {
                path: '/cards/diia_malyatko',
                widgetKey: 'widgets_malyatko'
            }),
            this.widgetsHelper.getWidgetsByPath.call(this, {
                path: '/cards/diia_childcare',
                widgetKey: 'widgets_childcare'
            })
        ];
        Promise.allSettled(fetches).then(() => {
            this.scrollToAndActivateTab({
                paramKeys: ['ebook', 'esport', 'screening', 'childcare'],
                stateKey: 'tabInfo',
                selector: '#info-new-tabs'
            });
        });
    }

    toggleInfoTab = tab => {
        this.setState({tabInfo: tab});
    };

    toggleShortQuestionTab = tab => {
        this.setState({tabShortQuestions: tab});
    };

    toggleAllQuestionsTab = tab => {
        this.setState({tabAllQuestions: tab});
    };
}
